module.exports = __webpack_public_path__ + "c6ed21902f8567e329cdb130e5716458.jpg";